import { Typography, Box } from '@mui/material'
import { useEffect } from 'react'
import { useTutorial } from '../../context/TutorialContext'
import BudgetTrackerComponent from '../../components/budget-tracker/BudgetTrackerComponent'
import ButtonCustom from '../../components/atoms/button/ButtonCustom'
import { useTutorialStatus } from '../../hooks/useTutorialStatus'

import styles from './budgetTrackerPage.module.scss'

export default function BudgetTrackerPage() {
  const { startTutorial, isTutorialActive } = useTutorial()
  const { hasSeenTutorial, isLoading } = useTutorialStatus('budget-tracker')

  useEffect(() => {
    // Start tutorial if it hasn't been seen and isn't already active
    if (!isLoading && !hasSeenTutorial && !isTutorialActive()) {
      const timer = setTimeout(() => {
        startTutorial('budget-tracker')
      }, 1000)
      return () => clearTimeout(timer)
    }
  }, [startTutorial, hasSeenTutorial, isTutorialActive, isLoading])

  return (
    	<div className={styles.pageWrap} data-cy="budget-tracker-page">
		<div className={styles.pageHeader}>
			<Typography component="h1">Budget Tracker</Typography>
			<div className={styles.right}>
            {/* TODO: uncomment when implemented */}
			{/* <ButtonCustom
				variant="outlined"
				size="lg"
				className={styles.exportPDF}
				data-cy="export-pdf-btn"
			>
				<img src="/images/export.svg" alt="export.svg" />
				<Typography variant="body">Export PDF</Typography>
			</ButtonCustom>
			<ButtonCustom
				variant="default"
				size="lg"
				className={styles.shareWithPartner}
				data-cy="share-with-partner-btn"
			>
				<img src="/images/share.svg" alt="share.svg" />
				<Typography variant="body">
				Share with Partner
				</Typography>
			</ButtonCustom> */}
			</div>
		</div>
		<BudgetTrackerComponent />
		</div>
	)
}
